module.exports = __webpack_public_path__ + "ae65659236a7e348402799477237e6fa.svg";